import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { constant } from "common/constant";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_JOB_OPENING_INITIAL_VALUES } from "common/initialValues/formInitialValues";
import { toast } from "react-toastify";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { putApi } from "common/services/api";
import { departmentTabsData } from "services/Recruit/data/tabsData";
import { DepartmentSchema } from "common/schema/department/departmentSchema";
import { addDepartment } from "common/redux/reducers/departmentSlice";
import Spinner from "common/components/spinner/Spinner";

const DepartmentCreate = () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { id } = useParams();
    const [jobData, setJobData] = useState(null);
    const { addLoading } = useSelector((state) => state.departments);
    const [editLoading, setEditLoading] = useState(false);
    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    useEffect(() => {
        if (id) {
            const fetchTaskData = async () => {
                try {
                    let result = await getApi(API_PATHS.RECRUITMENT_DEPARTMENTS, id);
                    setJobData(result?.data);
                } catch (e) {
                    toast.error(constant.somethingWrong);
                }
            };

            fetchTaskData()
        }
    }, [id])

    const EditData = async (values) => {
        try {
            setEditLoading(true);
            let response = await putApi(
                `${API_PATHS.RECRUITMENT_DEPARTMENTS}${id}`,
                values
            );
            if (response.status === 200) {
                navigate("/recruit/department");
            }
        } catch (e) {
            toast.error(constant.somethingWrong);
        }
        finally {
            setEditLoading(false);
        }
    };

    return (
        <>
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/department")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{id ? constant.editDepartment : constant.createDepartment}</Text>
                        </Box>
                    </Box>

                    <Formik
                        enableReinitialize
                        initialValues={
                            jobData
                                ? {
                                    ...jobData,
                                    department: jobData.department?._id || "",
                                }
                                : CREATE_JOB_OPENING_INITIAL_VALUES
                        }
                        validationSchema={DepartmentSchema}
                        onSubmit={(values, { resetForm }) => {
                            const departmentData = {
                                name: values.name,
                                description: values.description,
                            };

                            if (id) {
                                EditData(values);
                            } else {
                                dispatch(addDepartment({ values: departmentData, formik: { resetForm }, navigate }));
                            }
                        }}
                    >
                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {departmentTabsData.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="name">{constant.nameLabel}<span className="astrick">*</span></FormLabel>
                                                        <Field name="name">
                                                            {({ field, meta }) => {
                                                                return (
                                                                    <>
                                                                        <Input
                                                                            {...field}
                                                                            value={values.name}
                                                                            placeholder={constant.namePlaceHolder}
                                                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        />
                                                                        {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                    </>
                                                                );
                                                            }}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="description">{constant.description}</FormLabel>
                                                        <Field name="description">
                                                            {({ field, meta }) => {
                                                                return (
                                                                    <>
                                                                        <Textarea
                                                                            {...field}
                                                                            value={values.description}
                                                                            placeholder={constant.enterDescription}
                                                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        />
                                                                        {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                    </>
                                                                );
                                                            }}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button
                                                    variant="primary"
                                                    className="backBtn"
                                                    onClick={() => navigate("/recruit/referrals")}
                                                >
                                                    {constant.back}
                                                </Button>
                                                <Button
                                                    disabled={addLoading || editLoading || !isValid || (!id && !dirty)}
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                >
                                                    {(addLoading || editLoading) ? <Spinner size="sm" /> : id ? constant.update : constant.save}
                                                </Button>
                                            </Box>

                                        </TabPanel>

                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </>
    );
};

export default DepartmentCreate;
